require('@fontsource/open-sans/300.css')
require('@fontsource/open-sans/400.css')
require('@fontsource/open-sans/600.css')
require('@fontsource/open-sans/700.css')
require('./src/styles/global.scss')
require('./src/styles/_typography.scss')
require('./src/styles/layout.scss')
